module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_18.f86f8a88.pdf";